<template>
    <div class="cart">
        <slot v-bind="this"></slot>
    </div>
</template>

<script>
    import axios from 'axios';
    import Page from '../../../mixins/PageComponent';
    import { formatPrice } from "../../../util/price";

    export default {
        mixins: [Page],
        data() {
            return {
                total: this.data.total,
                items: this.data.items || [],
                editDate: this.data.editDate,
                showConfirm: false
            }
        },
        computed: {
            itemById() {
                return this.items.reduce((res,item) => {
                    res[item.id] = item;
                    return res;
                }, {});
            }
        },
        methods: {
            async post(endpoint) {
                let response = await axios.post(endpoint);
                this.update(response.data);
            },
            postForm(form) {
                this.post(form.action);
            },
            update(responseData) {
                let { data } = responseData;
                this.total = data.total;
                this.items = data.items;
            },
            format(price) {
                return formatPrice(price)
            },
            setEditDate(val) {
                this.editDate = val;
            },
            handleConfirmCancelled() {
                this.showConfirm = false;
            }
        }
    }
</script>